<template>
  <div class="home">
    <div>
      <header-barto></header-barto>
    </div>
    <div class="banner-header">
      <div class="banner">
        <div class="banner-inner">
          <p class="title">
            {{$t('homes.intoCapital')}}
          </p>
          <div class="search-bar">
            <div class="selects">
              <div class="select-btn" @click="changeSearchType(item.value)" :class="params.searchType === item.value ? 'active' : ''" v-for="item in searchTypeOptions" :key="item.value">{{ item.label }}</div>
            </div>
            <div class="search">
              <auto-complete
                popper-class="search-input-popper"
                ref="searchInput"
                size="medium"
                class="search-input"
                :class="params.searchType === 2 ? 'with-select' : ''"
                v-model="params.keyword"
                :trigger-on-focus="false"
                :select-when-unmatched="true"
                :placeholder="$t('homes.enter')+`${params.searchType === 1 ? $t('keyWord') : 
                params.searchType === 2 ?  $t('hsCode') : $t('companyName')}`+$t('homes.search')"
              >
                <el-select v-if="params.searchType === 2" v-model="params.countryId" slot="prepend" :placeholder="$t('dashboardCont.pleaseSelect')">
                  <el-option v-for="op in countryOptions" :key="op.value" :label="op.label" :value="op.value"></el-option>
                </el-select>
                <svg-icon slot="prefix" name="search"></svg-icon>
              </auto-complete>
           
            </div>
          </div>
        </div>
      </div>
      <div class="datas">
        <div class="datas-top">
          <div @mouseenter="e => changeActiveData(e, index)" @mouseleave="e => changeActiveData(e, index)" class="name" :class="{ active: activeData === index }" id="data-name" v-for="(item, index) in showDatas" :key="index">
            <svg-icon :name="item.icon" id="data-name"></svg-icon>
            <span id="data-name">{{ item.title }}</span>
          </div>
        </div>
        <div class="data-inner" id="data-inner">
          <template v-if="activeData > -1">
            <img class="left-img" v-if="activeData % 2 === 1" :src="activeDataObj.img" alt="" id="data-inner" />
            <div class="intro" id="data-inner">
              <p class="title" id="data-inner">{{ activeDataObj.title }}</p>
              <p class="sub-title" id="data-inner">{{ activeDataObj.en }}</p>
              <p class="text" id="data-inner" v-html="activeDataObj.text"></p>
            </div>
            <img class="right-img" v-if="activeData % 2 === 0" :src="activeDataObj.img" alt="" id="data-inner" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '@/components/header'
import HeaderBarto from '@/components/header'
// import FooterBar from '@/components/Footer'
import ChartContent from '@/components/Chart/chartContent'
import AutoComplete from '@/components/AutoComplete/autocomplete'
export default {
  name: 'Home',
  components: {
    HeaderBar,
    // FooterBar,
    ChartContent,
    AutoComplete,
    HeaderBarto
    // ElAutocompleteSuggestions
  },
  computed: {
    row () {
      return this.$route.query.row || 3
    },
    dataDetail () {
      return this.$store.getters.dataDetail
    },
    activeDataObj () {
      return this.activeData > -1 ? this.showDatas[this.activeData] : this.showDatas[0]
    }
    // autoOptionsVisible(){
    //   return this.$refs.searchInput?this.$refs.searchInput.suggestionVisible: false
    // }
  },
  data () {
    return {
      chartType: 2,
      params: {
        keyword: '',
        searchType: 1,
        countryId: 0
      },
      selectMultiple: false,
      searchTypeOptions: [
        {
          label: this.$t('homes.productName'),
          value: 1
        },
        {
          label: this.$t('homes.hsCode'),
          value: 2
        },
        {
          label: this.$t('homes.companyName'),
          value: 3
        }
      ],
      countryOptions: [
        {
          label: this.$t('homes.allCountry'),
          searchKeyword: this.$t('homes.allCountry'),
          value: 0
        }
      ],
      dataInfo: [],
      countryData: [],
      mapOptions: {},
      keywordOptions: [],
      activeData: -1,
      showDatas: [
        {
          title: this.$t('homes.strength'),
          icon: 'home-icon1',
          en: 'COMPREHENSIVE STRENGTH',
          img: require('@/assets/home/home-img1.png'),
          text: this.$t('homes.found')
        },
        {
          title: this.$t('homes.dataResources'),
          icon: 'home-icon2',
          en: 'DATA RESOURCE',
          img: require('@/assets/home/home-img2.png'),
          text: this.$t('homes.accumulation'),
        },
        {
          title:this.$t('homes.technical'),
          icon: 'home-icon3',
          en: 'TECHNICAL SKILLS',
          img: require('@/assets/home/home-img3.png'),
          text:this.$t('homes.useData'),
        },
        {
          title: this.$t('homes.serviceExperience'),
          icon: 'home-icon4',
          en: 'SERVICE EXPERIENCE',
          img: require('@/assets/home/home-img4.png'),
          text: this.$t('homes.absorbed'),
        }
      ]
    }
  },
  created () {
    // this.initHomeData()
    // this.getCountryOptions()
  },
  mounted () {
    // window.addEventListener('scroll', this.scroll)
    // this.$once('hook:beforeDestroy', function () {
    //   window.removeEventListener('scroll', this.scroll)
    // })
  },
  methods: {
    // getDataDetail () {
    //   this.$api.home.getHomeData().then(res => {
    //     this.$store.commit('set_data_detail', res.data)
    //   })
    // },
    // getCountryOptions () {
    //   return new Promise((resolve, reject) => {
    //     this.$api.public.getCountryOptions().then(res => {
    //       let data = [
    //         {
    //           label: this.$t('homes.allCountry'),
    //           value: 0
    //         }
    //       ]
    //       res.data.forEach(item => {
    //         data = [...data, ...item.children.filter(c => c.dataType.length > 0)]
    //       })
    //       this.countryOptions = data
    //     })
    //   })
    // },
    // getFlags () {
    //   return new Promise((resolve, reject) => {
    //     this.$api.public.getFlags().then(res => {
    //       resolve(res)
    //     })
    //   })
    // },
    initHomeData () {
      // Promise.all([this.$api.home.getHomeData()]).then(response => {
      // const res = this.dataDetail
      // this.dataInfo = res.summary
      // this.countryData = res.country
      // let datas = []
      // res.country.forEach(item => {
      //   // item.name = item.nameCn
      //   datas = [
      //     ...datas,
      //     ...item.children.map(c => {
      //       c.value = c.coord
      //       return c
      //     })
      //   ]
      // })
      // const sourceData = JSON.parse(JSON.stringify(datas))
      // let series = [{
      //   type: 'map',
      //   // geoIndex: 1,
      //   roam: false,
      //   tooltip: {
      //     show: true,
      //     alwaysShowContent: false,
      //     // triggerOn: 'click',
      //     // appendToBody: true,
      //     enterable: true,
      //     // renderMode: 'html',
      //     backgroundColor: "#ffffff",
      //     borderWidth: 0.5,
      //     borderColor: "#999999",
      //     formatter: function (val) {
      //       // return val.data ? `<div>
      //       //             <span style="font-size: 16px;"><img style="height: 16px;width:24px" src="${val.data.flag}" /></span><span style="color:#000;font-size:14px;font-weight:bold;padding-left:5px;">${val.data.name}</span>
      //       //             <p style="color: #666;font-size:12px;padding-bottom: 5px;">${val.data.dataTypes.join(' | ')}</p>
      //       //             <p style="color: #666;font-size:12px;">包含企业数：${val.data.companyCount}</p>
      //       //             <p style="color: #666;font-size:12px;">包含数据数：${val.data.dataCount}</p>
      //       //           </div>`: false
      //     },
      //     // data: sourceData.map(d => {
      //     //   let cn = d.name
      //     //   d.name = d.nameEn
      //     //   d.nameCn = cn
      //     //   return d
      //     // })
      //   },
      //   itemStyle: {
      //     normal: {
      //       areaColor: '#D6D8E0',
      //       borderColor: '#ffffff',
      //       // borderWidth: 1,
      //       shadowColor: '#ffffff',
      //       shadowOffsetX: 0,
      //       shadowOffsetY: 1
      //     },
      //   },
      //   map: 'world' //使用
      // }, {
      //   type: 'scatter',
      //   // geoIndex: 1,
      //   coordinateSystem: 'geo',
      //   zlevel: 1,
      //   rippleEffect: {
      //     brushType: 'stroke'
      //   },
      //   symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAABMUlEQVQ4T62TPyiEcRjHP885OjrpBllkulJImW1HSnYlMknJKRkMyqQMBpSTkkmk7FLiNrMSSt0kiwyX7uKN49Hz9p7ecPX23v3W3/f76fnzfYQqn/z2q2o3MAUMAR3e/wNwBuyJyK3f8wNQ1QZgHZgBIhUK+wJ2gAUReTeNC/DMp0BKVXEuDnGyR5Qe711OtL2TWGqM2MA4Iq4lCwwbpAzIALOf+ScKW2k+bi7/LaC+p5/muQx1iTb73xaRtHg9X6tq5GVltKK5TDRIy/KxVWLt9BpgA5h/Oz+guLsYaCfx6TUaBydMu2kAm2pXfmmEUu4qECCa7COxemLaOwMUgPjzZBKc10AAYk207udMW6wJoOoWqh6iRTf8Gr0khg9STaLsg4Q7Jv/yQ59zsAT9VX0DOha2/2Lm3BQAAAAASUVORK5CYII=',
      //   symbolSize: function (val) {
      //     return [8, 9];
      //   },
      //   tooltip: {
      //     alwaysShowContent: false,
      //     // triggerOn: 'click',
      //     // appendToBody: true,
      //     enterable: true,
      //     // renderMode: 'html',
      //     backgroundColor: "#ffffff",
      //     borderWidth: 0.5,
      //     borderColor: "#999999",
      //     formatter: function (val) {
      //       return val.data ? `<div>
      //                   <span style="font-size: 16px;"><img style="height: 16px;width:24px" src="${val.data.flag}" /></span><span style="color:#000;font-size:14px;font-weight:bold;padding-left:5px;">${val.data.name}</span>
      //                   <p style="color: #666;font-size:12px;padding-bottom: 5px;">${val.data.dataTypes.join(' | ')}</p>
      //                   <p style="color: #666;font-size:12px;">包含企业数：${val.data.companyCount}</p>
      //                   <p style="color: #666;font-size:12px;">包含数据数：${val.data.dataCount}</p>
      //                 </div>`: false
      //     },
      //     rich: {
      //       a: {
      //         fontSize: 16,
      //         fontWeight: "bold",
      //         paddingLeft: 10,
      //         color: "#000"
      //       },
      //       b: {
      //         fontSize: 12,
      //         color: "#666",
      //         paddingBottom: 30
      //       },
      //       c: {
      //         fontSize: 12,
      //         color: "#666",
      //         paddingBottom: 5
      //       }
      //     }
      //   },
      //   labelLine: {
      //     show: true,
      //     length2: 5,
      //     lineStyle: {
      //       color: '#bbb'
      //     }
      //   },
      //   // label: {
      //   //   show: true,
      //   //   formatter: `{name}`
      //   // },
      //   data: sourceData.map(d => {
      //     d.label = {
      //       show: true,
      //       position: 'right',
      //       formatter: `{icon|}{back|}{flag|}{name|}`,
      //       rich: {
      //         icon: {
      //           width: 6,
      //           height: 8,
      //           backgroundColor: {
      //             image: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAOCAYAAAAWo42rAAAAAXNSR0IArs4c6QAAAFBlWElmTU0AKgAAAAgAAgESAAMAAAABAAEAAIdpAAQAAAABAAAAJgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAACqADAAQAAAABAAAADgAAAADcJTArAAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNi4wLjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgoZXuEHAAAAkElEQVQoFYWSTQ5AMBBGy1Ji7wSO4CxWOI9LcAmHcBJ7YmGj3lhIW1OavGTmm68/09aYn2GtLWGK2ijm0MMB9mVES6CDBZ7hGVErmJ+qE9xG8gJGOJ2aFxqyGlZPVRI5z86ymXcGJUkVTZXE2MCmVkOR7aWZAeLNuJMwfl9PYJYGW4hfeDDh+wlds8SsfH+KC17C/n9gAxmGAAAAAElFTkSuQmCC`
      //           }
      //         },
      //         back: {
      //           align: 'left',
      //           padding: [7, 6],
      //           width: d.flag ? 29 + d.name.length * 14 : d.name.length * 14,
      //           fontSize: 14,
      //           borderRadius: 3,
      //           shadowColor: "rgba(0, 0, 0, 0.1)",
      //           shadowBlur: 4,
      //           shadowOffsetX: 0,
      //           shadowOffsetY: 2,
      //           backgroundColor: 'rgba(255,255,255,1)',
      //         },
      //         name: {
      //           align: 'left',
      //           color: 'transparent',
      //           fontSize: 14,
      //           lineHeight: 28,
      //         },
      //         flag: {
      //           verticalAlign: 'middle',
      //           align: 'left',
      //           width: 24,
      //           height: 16,
      //           backgroundColor: 'transparent'
      //         },
      //       }
      //     }
      //     return d
      //   })
      // }, {
      //   type: 'scatter',
      //   // geoIndex: 1,
      //   coordinateSystem: 'geo',
      //   zlevel: 2,
      //   rippleEffect: {
      //     brushType: 'stroke'
      //   },
      //   symbolSize: 7,
      //   itemStyle: {
      //     normal: {
      //       show: true,
      //       color: 'transparent',
      //       fontWeight: 'bolder'
      //     }
      //   },
      //   // labelLayout: function () {
      //   //   return {
      //   //     x: 100,
      //   //     moveOverlap: 'shiftY'
      //   //   };
      //   // },
      //   labelLayout(params) {
      //       return {
      //           x: params.rect.x + 10,
      //           y: params.rect.y + params.rect.height / 2,
      //           verticalAlign: 'middle',
      //           align: 'left'
      //       }
      //   },
      //   labelLine: {
      //     show: true,
      //     length2: 10,
      //     minTurnAngle: 45,
      //     lineStyle: {
      //       color: '#000'
      //     }
      //   },
      //   label: {
      //     show: true,
      //     position: 'right',
      //     color: '#000',
      //     formatter: function (param) {
      //       return param.name;
      //     },
      //   },
      //   data: datas.map(d => {
      //     // d.labelLine = {
      //     //   show: true,
      //     //   length2: 5,
      //     //   lineStyle: {
      //     //     color: '#bbb'
      //     //   }
      //     // }
      //     d.label = {
      //       show: true,
      //       position: 'right',
      //       offset: [13, 0],
      //       formatter: function (val) {
      //         return `{flag|}{name|${val.name}}`
      //       },
      //       rich: {
      //         name: {
      //           align: 'left',
      //           color: '#333333',
      //           fontSize: 14,
      //           lineHeight: 28,
      //           padding: [0, 0, 0, d.flag ? 5 : 0],
      //         },
      //         flag: {
      //           align: 'left',
      //           verticalAlign: 'middle',
      //           backgroundColor: {
      //             image: d.flag
      //           }
      //         },
      //       }
      //     }
      //     return d
      //   })
      // }]
      // this.mapOptions = {
      //   title: {
      //     left: 'left',
      //     textStyle: {
      //       color: '#fff'
      //     }
      //   },
      //   tooltip: {
      //     alwaysShowContent: false,
      //     // triggerOn: 'click',
      //     // appendToBody: true,
      //     enterable: true,
      //     // renderMode: 'html',
      //     backgroundColor: "#ffffff",
      //     borderWidth: 0.5,
      //     borderColor: "#999999",
      //     formatter: function (val) {
      //       return val.data ? `<div>
      //                   <span style="font-size: 16px;"><img style="height: 16px;width:24px" src="${val.data.flag}" /></span><span style="color:#000;font-size:14px;font-weight:bold;padding-left:5px;">${val.data.name}</span>
      //                   <p style="color: #666;font-size:12px;padding-bottom: 5px;">${val.data.dataTypes.join(' | ')}</p>
      //                   <p style="color: #666;font-size:12px;">包含企业数：${val.data.companyCount}</p>
      //                   <p style="color: #666;font-size:12px;">包含数据数：${val.data.dataCount}</p>
      //                 </div>`: false
      //     },
      //     rich: {
      //       a: {
      //         fontSize: 16,
      //         fontWeight: "bold",
      //         paddingLeft: 10,
      //         color: "#000"
      //       },
      //       b: {
      //         fontSize: 12,
      //         color: "#666",
      //         paddingBottom: 30
      //       },
      //       c: {
      //         fontSize: 12,
      //         color: "#666",
      //         paddingBottom: 5
      //       }
      //     }
      //   },
      //   // tooltip: {
      //   //   alwaysShowContent: false,
      //   //   // triggerOn: 'click',
      //   //   // appendToBody: true,
      //   //   enterable: true,
      //   //   // renderMode: 'html',
      //   //   backgroundColor: "#ffffff",
      //   //   borderWidth: 0.5,
      //   //   borderColor: "#999999",
      //   //   formatter: function(val) {
      //   //     return val.data?`<div>
      //   //               <span style="font-size: 16px;"><img src="${val.data.flag}" /></span><span style="color:#000;font-size:14px;font-weight:bold;padding-left:5px;">${val.data.name}</span>
      //   //               <p style="color: #666;font-size:12px;padding-bottom: 5px;">${val.data.dataTypes.join(' | ')}</p>
      //   //               <p style="color: #666;font-size:12px;">包含企业数：${val.data.companyCount}</p>
      //   //               <p style="color: #666;font-size:12px;">包含数据数：${val.data.dataCount}</p>
      //   //             </div>`:false
      //   //   },
      //   //   rich: {
      //   //     a: {
      //   //       fontSize: 16,
      //   //       fontWeight: "bold",
      //   //       paddingLeft: 10,
      //   //       color: "#000"
      //   //     },
      //   //     b: {
      //   //       fontSize: 12,
      //   //       color: "#666",
      //   //       paddingBottom: 30
      //   //     },
      //   //     c: {
      //   //       fontSize: 12,
      //   //       color: "#666",
      //   //       paddingBottom: 5
      //   //     }
      //   //   }
      //   // },
      //   geo: {
      //     geoIndex: 1,
      //     map: 'world',
      //     label: {
      //       emphasis: {
      //         show: false
      //       }
      //     },
      //     scaleLimit: {
      //       min: 1,
      //       max: 1
      //     },
      //     roam: false,
      //     itemStyle: {
      //       normal: {
      //         areaColor: '#D6D8E0',
      //         // areaColor:{
      //         //   type: 'radial',
      //         //   x: 0.5,
      //         //   y: 0.5,
      //         //   r: 0.8,
      //         //   colorStops: [{
      //         //       offset: 0,
      //         //       color: '#09132c' // 0% 处的颜色
      //         //   }, {
      //         //       offset: 1,
      //         //       color: '#274d68'  // 100% 处的颜色
      //         //   }],
      //         //   globalCoord: true // 缺省为 false
      //         // },
      //         borderColor: '#ffffff',
      //         shadowColor: '#EDF3FD',
      //         shadowOffsetX: 2,
      //         shadowOffsetY: 3
      //       },
      //       emphasis: {
      //         areaColor: '#D6D8E0',
      //         borderColor: '#ffffff'
      //       }
      //     }
      //   },
      //   series: series,
      // }
      // })
    },
    changeSearchType (val) {
      this.$refs.searchInput.suggestions = []
      this.keywordOptions = []
      this.params.keyword = ''
      this.params.searchType = val
      this.params.countryId = 0
    },
    querySearch (queryString, cb) {
      this.keywordOptions = []
      const params = {
        keyword:queryString,
        searchType: this.params.searchType,
        countryId: this.params.coutnryId
      }
      if (this.params.searchType === 2) {
        const canSearch = this.$util.checkHsCode(queryString)
        if (!canSearch) {
          this.keywordOptions = []
          cb([])
          return
        }
      }
      this.$api.company
        .getSearchKeywordOptions(params)
        .then(res => {
           const data = [];
          const data1 = []
          const data2 = []
          const data3 = [];
            res.data.forEach(item => {
             if (item.type === 1) {
              data1.push(item)
            }else if (item.type === 2) {
              data2.push(item)
            }else if(item.type === 3){
              data3.push(item);
            };
          })
          if (data1.length > 0) {
            data.push({
              label: this.$t('resultTop.recommendedKeywords'),
              value: 1,
              children: data1
            })
          }
          if (data2.length > 0) {
            data.push({
              label: this.$t('resultTop.relevantHScode'),
              value: 2,
              children: data2
            })
          };
          if (data3.length > 0) {
           data.push({
            label: this.$t('resultTop.lenovoCompanyName'),
            value: 3,
            children: data3
          })
        }
          this.keywordOptions = data
          cb(data)
          // cb([
          //   {
          //     label: '联想关键词',
          //     value: 1,
          //     children: data1
          //   },
          //   {
          //     label: '推荐关键词',
          //     value: 2,
          //     children: data2
          //   }
          // ])
        })
        .catch(err => {
          cb([])
        })
    },
  
    createFilter (queryString) {
      return restaurant => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1
      }
    },
    changeChartType () {
      this.chartType = this.chartType === 1 ? 2 : 1
    },
    scroll () {
      // this.scrollTop = document.documentElement.scrollTop
    },
    changeActiveData (e, index) {
      if (e.type === 'mouseenter') {
        this.activeData = index
      } else {
        if ((!e.toElement || e.toElement.id !== 'data-name') && (!e.toElement || e.toElement.id !== 'data-inner')) {
          setTimeout(() => {
            this.activeData = -1
          }, 800)
        }
      }
    }
  },
  watch: {
    
  }
}
</script>
<style lang="scss">
.case-select {
  min-width: unset;
  .case-change {
    .case {
      cursor: pointer;
    }
  }
}
.search-input-popper {
  .el-autocomplete-suggestion__wrap {
    // max-height: 415px;
  }
  .el-autocomplete-suggestion__list {
    .type {
      .type-name {
        padding: 10px 15px;
        font-size: 12px;
        color: $--color-font-light;
        border-bottom: 1px solid $--color-border-light;
      }
      .search-op {
        padding: 8px 15px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        &:hover {
          background-color: mix($--color-white, $--color-primary, 90%);
        }
        .search-name {
          flex: 1;
          white-space: nowrap;
        }
        .search-des {
          white-space: nowrap;
          font-size: 12px;
          max-width: 400px;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $--color-font-light;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.home {
  padding-top: 0;
  background-color: rgba(247, 248, 251, 1);
  .header-bar {
    width: 100%;
    box-sizing: border-box;
    background-color: #ffffff;
    box-shadow: none;
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    border-bottom: 1px solid rgba(222, 222, 222, 0.3);
  }
  .banner-header {
    height:800px;
    .banner {
      height: calc(100vh - 60px);
      background-color: #ffffff;
      // background: url(../assets/banner.jpg);
      // background: url(../assets/home/banner.png) center;
      background-size: cover;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      // padding: 92px 0 116px;
      // padding: 170px 0 170px;
      .banner-inner {
        transform: translateY(-150px);
        // padding: 90px 0 100px;
      }
      .title {
        // color: #ffffff;
        color: rgba(26, 23, 59, 1);
        font-weight: 400;
        font-size: 44px;
        text-align: center;
        letter-spacing: 1px;
      }
      .sub-title {
        text-align: center;
        margin: 20px 0 30px;
      }
      .search-bar {
        margin-top: 32px;
        display: flex;
        flex-direction: column;
        align-items: center;
        /deep/.el-radio-group {
          color: #ffffff;
          .el-radio__input {
            .el-radio__inner {
              // border-color: #ffffff;
            }
            &.is-checked {
              .el-radio__inner {
                border-color: #ffffff;
                background-color: transparent;
                border-width: 3px;
                &::after {
                  background-color: transparent;
                }
              }
            }
          }
          .el-radio__label {
            color: #ffffff;
          }
        }
        .selects {
          display: flex;
          padding: 0 25px;
          background: #f9f9f9;
          border-radius: 22px;
          .select-btn {
            padding: 15px;
            position: relative;
            cursor: pointer;
            &.active {
              // background: linear-gradient(270deg, #dd2c00 0%, #dd3e16 100%);
              // background-color: rgba(231, 113, 50, 1);
              border-radius: 6px;
              color: #ea5519;
              &::after {
                content: ' ';
                width: 0;
                height: 0;
                display: block;
                border: 8px solid transparent;
                // border-top-width: 8px;
                border-left-width: 5px;
                border-right-width: 5px;
                border-top-color: #f9f9f9;
                position: absolute;
                left: 50%;
                bottom: -15px;
                transform: translateX(-50%);
              }
            }
          }
        }
        .search {
          padding-top: 22px;
          display: flex;
          .confirm-btn {
            height: 36px;
            padding: 0 20px;
            margin-left: 16px;
          }
        }
        /deep/.search-input {
          width: 690px;
          display: flex;
          height: 44px;
          &.with-select {
            .el-input-group__prepend {
              border-radius: 22px 0 0 22px;
            }
            > .el-input > .el-input__inner {
              border-radius: 0 22px 22px 0 !important;
            }
          }
          .el-input-group__prepend {
            width: 80px;
            background-color: #ffffff;
            color: $--color-font;
            border-color: #dedede;
          }
          > .el-input > .el-input__inner {
            padding-left: 54px;
            height: 44px;
            border-radius: 22px;
            border-color: #dedede;
          }
          input::-webkit-input-placeholder {
            color: $--color-font-light;
          }
          input::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: $--color-font-light;
          }
          input:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: $--color-font-light;
          }
          input:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: $--color-font-light;
          }
          .el-input__prefix {
            display: flex;
            align-items: center;
            padding-left: 15px;
            color: $--color-font-light;
          }
          .el-input__suffix {
            right: 4px;
            .el-button {
              margin-top: 4px;
            }
          }
          /deep/.search-select {
            width: 450px;
            .el-input__suffix {
              display: none;
            }
            .el-input__inner {
              border-top-right-radius: 0;
              border-bottom-right-radius: 0;
            }
          }
          .confirm-btn {
            height: 36px;
            padding: 0 20px;
            &:hover,
            &:active,
            &:focus {
              height: 36px;
            }
          }
          .select-tag {
            background-color: #d8d8d8;
            border-radius: 4px;
            padding: 4px;
            width: fit-content;
            margin-right: 4px;
          }
          .select-option {
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }
    .datas {
      position: fixed;
      bottom: 0;
      width: 100%;
      background-color: #ffffff;
      &:hover {
        .data-inner {
          max-height: 428px;
        }
      }
      .datas-top {
        display: flex;
        align-items: center;
        cursor: pointer;
        .name {
          flex: 1;
          padding: 26px 47px;
          text-align: center;
          display: flex;
          align-items: center;
          color: #32404a;
          justify-content: center;
          font-weight: 500;
          span {
            margin-left: 6px;
          }
          &.active {
            color: $--color-default;
            border-bottom: 2px solid $--color-default;
          }
        }
      }
      .data-inner {
        display: flex;
        justify-content: center;
        align-items: center;
        max-height: 0px;
        transition: max-height 0.8s ease-in-out;
        overflow: hidden;
        background-color: #fcfcfc;
        flex-wrap: wrap;
        .intro {
          width: 406px;
          .title {
            font-size: 16px;
            font-weight: 500;
            color: #32404a;
          }
          .sub-title {
            font-size: 12px;
            color: #32404a;
            font-weight: 500;
            margin-top: 8px;
          }
          .text {
            color: #666666;
            line-height: 28px;
            margin-top: 21px;
          }
        }
        img {
          height: 310px;
          padding: 59px 0;
          &.left-img {
            margin-right: 73px;
          }
          &.right-img {
            margin-left: 73px;
          }
        }
      }
    }
  }
  // .datas {
  //   width: 100%;
  //   background-color: #fafafa;
  //   border-bottom: 1px solid rgba(222, 222, 222, 1);
  //   .data-inner {
  //     display: flex;
  //     padding: 22px 0;
  //     .data-item {
  //       flex: 1;
  //       text-align: center;
  //       display: flex;
  //       align-items: center;
  //       > div {
  //         width: 100%;
  //       }
  //       .count {
  //         color: #1d1745;
  //         font-size: 34px;
  //         font-weight: 400;
  //       }
  //       .name {
  //         color: rgba(189, 194, 205, 1);
  //         margin-top: 10px;
  //       }
  //       &:not(:last-of-type) {
  //         &::after {
  //           content: ' ';
  //           width: 1px;
  //           height: 40px;
  //           background-color: #dfe3e9;
  //         }
  //       }
  //     }
  //   }
  // }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background-color: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    padding: 81px 80px 53px 100px;
    .title {
      font-size: 28px;
      color: rgba(26, 23, 59, 1);
      text-align: center;
      margin-bottom: 24px;
    }
    .btn {
      color: rgba(234, 85, 25, 1);
      cursor: pointer;
      i {
        font-size: 10px;
      }
    }
    .sub-title {
      text-align: center;
      line-height: 1.5;
    }
    .map {
      width: 100%;
      margin: 30px auto;
    }
    .chart {
      height: 600px;
    }
    .data-list {
      align-self: flex-start;
      margin-top: 87px;
      .list-row {
        display: flex;
        margin-bottom: 19px;
        &:last-of-type {
          margin-bottom: 0;
        }
        .continent-name {
          color: #1a173b;
          font-size: 16px;
          font-weight: 400;
          min-width: 80px;
          text-align: right;
        }
        .countrys {
          display: flex;
          flex-wrap: wrap;
          margin-left: 30px;
          .country {
            color: #637280;
            margin-right: 40px;
            margin-bottom: 27px;
            .name {
              color: #1a173b;
              display: flex;
              align-items: center;
              padding-bottom: 9px;
              img {
                margin-right: 10px;
                height: 16px;
              }
              span {
                line-height: 16px;
              }
            }
            .data-type {
              font-size: 12px;
              &::after {
                position: relative;
                top: 2px;
                content: ' ';
                display: inline-block;
                width: 1px;
                height: 12px;
                background-color: currentColor;
                margin: 0 8px;
              }
              &:last-of-type {
                &::after {
                  display: none;
                }
              }
            }
            p {
              font-size: 12px;
              margin-top: 16px;
            }
          }
        }
      }
    }
  }
}
</style>
